import {z} from 'zod';

import {FinancialProductMoneySchema} from './FinancialProductMoneySchema';

/**
 * One offerable leasing coordinate with its own monthly rate: `monthlyRate` is GROSS (VAT
 * included, as configured), `monthlyRateNet` is NET (the backend's VAT-exclusive figure, shown to
 * COMMERCIAL customers). The backend withholds both (null on every cell of the offer) when the
 * product is not offered today; they are optional until every backend publishes them, and absent
 * means the same as withheld.
 */
export const LeasingCellSchema = z.object({
  termMonths: z.number(),
  annualMileage: z.number(),
  monthlyRate: FinancialProductMoneySchema.nullable().optional(),
  monthlyRateNet: FinancialProductMoneySchema.nullable().optional(),
});
export type LeasingCell = z.infer<typeof LeasingCellSchema>;
